/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/PortalUser/PortalUsers',[
    'jquery',
    'global/all',
    './PortalUsers.Forms'
], function ($, Roc, PortalUsersForms) {
    'use strict';

    var loginOptions;
    var loginData;
    var registrationOptions;
    var editUserData;
    var editAccountOptions = {};
    var editAccountData;
    var forgotPasswordOptions;
    var changePasswordData;
    var states = {};

    // Forms definitions
    var forms = PortalUsersForms;

    //  Enter handlers
    function handlePortalLoginEnterEvt() {
        Roc.Core.handleEnter('#portalLoginEmail, #portalLoginPassword', portalLogin);
    }

    function handlePortalRegistrationEnterEvt() {
        Roc.Core.handleEnter('#portalRegisterFirstName, #portalRegisterLastName, #portalRegisterEmail, #portalRegisterEmail2, #portalRegisterPassword, #portalRegisterPassword2 , #portalRegisterOrganization , #portalRegisterPhone, #portalRegisterAccountNumber ', portalRegister);
    }

    function handleEditAccountEnterEvt() {
        Roc.Core.handleEnter('#current-password, #new-password, #new-password-confirm', editAccount);
    }
    function handleForgotPasswordEnterEvt() {
        Roc.Core.handleEnter('#forgot_email', forgotPassword);
    }
    function handleChangePasswordEnterEvt() {
        Roc.Core.handleEnter('#forgot_password, #forgot_password2', changePassword);
    }

    // Specific events

    var btns = {
        portalLogin: '#portalLoginBtn',
        portalRegister: '#portalRegisterBtn',
        portalRequestAccount: '#portalRequestBtn',
        editAccount: '#editAccountSaveBtn',
        editAccountCancel: '#editAccountCancelBtn',
        editProfile: '#editProfileSaveBtn',
        editProfileCancel: '#editProfileCancelBtn',
        changePass: '#changePasswordBtn',
        forgotPass: '#forgotPasswordBtn'
    };

    var selectors = {
        manageProfileContainer: '#manageProfileContainer',
        linkedInProfileInput: '#linkedin-profile'
    };


    //Portal Custom Code     

    function portalLoginEvt() {
        $(document)
            .off('click', btns.portalLogin)
            .on('click', btns.portalLogin, function (e) {
                e.preventDefault();
                portalLogin();
            });
    }

    function portalRegisterEvt() {
        $(document)
            .off('click', btns.portalRegister)
            .on('click', btns.portalRegister, function (e) {
                e.preventDefault();
                portalRegister();
            });
    }

    function onRequestAccount() {
        if (loginOptions && loginOptions.requestAccountUrl) {
            window.location.href = loginOptions.requestAccountUrl;
        } else {
            Roc.Logger.warn('Unable to redirect to Request an Account page');
        }
    }

    function editAccountSaveEvt() {
        $(document)
            .off('click', btns.editAccount)
            .on('click', btns.editAccount, function (e) {
                e.preventDefault();
                Roc.Core.lockButton(btns.editAccount);
                editAccount();
            });
    }

    function editProfileSaveEvt() {
        $(document)
            .off('click', btns.editProfile)
            .on('click', btns.editProfile, function (e) {
                e.preventDefault();
                Roc.Core.lockButton(btns.editProfile);
                editUserProfile();
            });
    }

    function editAccountCancelEvt() {
        $(document)
            .off('click', btns.editAccountCancel)
            .on('click', btns.editAccountCancel, function (e) {
                e.preventDefault();
                Roc.Core.lockButton(btns.editAccountCancel);
                window.location.href = document.URL;
            });
    }

    function editProfileCancelEvt() {
        $(document)
            .off('click', btns.editProfileCancel)
            .on('click', btns.editProfileCancel, function (e) {
                e.preventDefault();
                Roc.Core.lockButton(btns.editProfileCancel);
                window.location.href = document.URL;
            });
    }

    function forgotEvt() {
        $(document)
            .off('click', btns.forgotPass)
            .on('click', btns.forgotPass, function (e) {
                e.preventDefault();
                forgotPassword();
            });
    }

    function changePasswordEvt() {
        $(document)
            .off('click', btns.changePass)
            .on('click', btns.changePass, function (e) {
                e.preventDefault();
                changePassword();
            });
    }


        
    // START: Events binding

    function bindPortalLoginEvents() {
        handlePortalLoginEnterEvt();
        portalLoginEvt();
        // customized for HT: redirect to "Request an Account" page when clicking request account button
        Roc.UI.siteBody
            .off('click', btns.portalRequestAccount)
            .on('click', btns.portalRequestAccount, onRequestAccount);
    }

    function bindPortalRegistrationEvents() {
        handlePortalRegistrationEnterEvt();
        registerStateDrpEvt();
        portalRegisterEvt();
        //bindAddressAutoCompleteEvt();
        Roc.EventManager.bind(Roc.Events.users.PORTALREGISTER, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.redir) {
                Roc.Core.lockButton(btns.register);
                window.location.replace(response.redir);
            }
        });
    }

    function registerStateDrpEvt() {
        var selector = '#portalRegisterCountry';
        $(document).off('change', selector).on('change', selector, function () {
            buildStateDrpHtml($(this).val());
        });
    }

    function buildStateDrpHtml(countryCode) {
        if (countryCode === 'US') {
            buildHtml(registrationOptions.usStates);
        } else if (countryCode === 'CA') {
         
            buildHtml(registrationOptions.caStates);
        }
        else if (countryCode === 'MX') {
            buildHtml(registrationOptions.mxStates);
        } else {
            buildHtml();
        }
    }

    function buildHtml(listOfStates) {
        Roc.UI.template('#RegistrationStates-Tmp', listOfStates).then(function (renderedTemplate) {
            $('#portalRegisterState').html(renderedTemplate);
        });
    }

    function bindUserProfileEvents() {
        editProfileSaveEvt();
        editProfileCancelEvt();
    }


    function bindEditAccountEvents() {
        handleEditAccountEnterEvt();
        editAccountSaveEvt();
        editAccountCancelEvt();
    }

    function bindForgotPasswordEvents() {
        handleForgotPasswordEnterEvt();
        handleChangePasswordEnterEvt();
        forgotEvt();
        changePasswordEvt();
    }

    function portalLogin() {
        var $formWrapper = $(forms.PortalLogin.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.PortalLogin);

        if (isValid) {
            Roc.Core.lockButton(btns.portalLogin);
            var requestData = Roc.Validation.getFieldValues(forms.PortalLogin);

            requestData.isCheckout = loginOptions.isCheckout || false;

            $.ajax({
                url: '/ajax/PortalLogin',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: loginOptions.beforeSend || null,
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};

                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    }
                    Roc.Core.releaseLockedButton(btns.portalLogin);
                    Roc.EventManager.notify(Roc.Events.users.PORTALLOGIN, xhr);
                }
            });
        }
    }

    function portalRegister() {
       
        var Statename = $("#portalRegisterState option:selected").text();
        var $formWrapper = $(forms.PortalRegistration.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        $errorContainer.html('');
        var isValid = Roc.Validation.validateForm(forms.PortalRegistration);
        if (isValid) {
            Roc.Core.lockButton(btns.portalRegister);
            var requestData = Roc.Validation.getFieldValues(forms.PortalRegistration);
            requestData.authenticateUser = registrationOptions.authenticateUser;
            requestData.duringCheckout = registrationOptions.duringCheckout;
            requestData.Statename = Statename;
            //var data = {
            //    FirstName: $('#portalRegisterFirstName').val(),
            //};
          

            $.ajax({
                url: '/ajax/PortalRegister',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: registrationOptions.beforeSend || null,
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    } else if (response.responseText) {
                        $("#portalRegistrationSuccessMessage").text(response.responseText);
                        $("#portalRegistrationSuccess").show();
                        $("#portalRegistrationForm").hide();
                    }
                    setApiSideCustomFields({
                        externalUserId: response.externalUserId,
                        phoneNumber: requestData.phoneNumber,
                        accountNumber: requestData.accountNumber,
                        jobTitle: requestData.jobTitle,
                        billingStreetAddress: requestData.billingStreetAddress,
                        city: requestData.city,
                        zip: requestData.zip,
                        state: requestData.state,
                        country: requestData.country,
                    }).always(function () {
                        Roc.Core.releaseLockedButton(btns.portalRegister);
                        Roc.EventManager.notify(Roc.Events.users.REGISTER, xhr);
                    });
                }
            });
        }
        return isValid;
    }

    function editUserProfile() {
        var $formWrapper = $(forms.EditProfile.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.EditProfile);

        if (isValid) {
            var requestData = Roc.Validation.getFieldValues(forms.EditProfile);
            $.ajax({
                url: '/ajax/EditUserProfile',
                type: 'POST',
                data: JSON.stringify(requestData),
                contentType: 'application/json',
                dataType: 'json',
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage })
                            .then(function (renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                    } else {
                        setUserLinkedInCustomField({
                            linkedInProfile: requestData.linkedInProfile
                        }).always(function () {
                            Roc.Core.releaseLockedButton(btns.editProfile);
                            Roc.EventManager.notify(Roc.Events.users.PORTAL_EDIT_ACCOUNT, xhr);
                        });
                    }
                }
            });
        }
    }

    function editAccount() {
        var $formWrapper = $(forms.EditAccount.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.EditAccount);

        $errorContainer.html('');

        if (isValid) {
            if (editAccountData.$newPass1.val() !== editAccountData.$newPass2.val()) {
                Roc.UI.template('formErrorSummary-Tmp', { message: '"New Password" and "Confirm New Password" aren\'t the same' }).then(function (renderedTemplate) {
                    $errorContainer.html(renderedTemplate);
                });
            } else {
                Roc.Core.lockButton(btns.editAccount);
                var requestData = Roc.Validation.getFieldValues(forms.EditAccount);

                $.ajax({
                    url: '/ajax/PortalEditAccount',
                    type: 'POST',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json',
                    dataType: 'json',
                    complete: function (xhr) {
                        var response = xhr.responseJSON || {};
                        if (response.errorMessage) {
                            Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                        }
                        Roc.Core.releaseLockedButton(btns.editAccount);
                        Roc.EventManager.notify(Roc.Events.users.PORTAL_EDIT_ACCOUNT, xhr);
                    }
                });
            }
        }
    }

    function forgotPassword() {
        var $formWrapper = $(forms.ForgotPassword.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.ForgotPassword);

        $errorContainer.html('');

        if (isValid) {
            Roc.Core.lockButton(btns.forgotPass);
            var requestData = Roc.Validation.getFieldValues(forms.ForgotPassword);

            $.ajax({
                url: '/ajax/SendPortalForgotPasswordEmail',
                type: 'POST',
                data: JSON.stringify(requestData),
                contentType: 'application/json',
                dataType: 'json',
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.success) {
                        $('#forgotForm').hide();
                        $('#checkEmail').show();
                    }

                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    }
                    Roc.Core.releaseLockedButton(btns.forgotPass);
                    Roc.EventManager.notify(Roc.Events.users.FORGOT_PASSWORD, xhr);
                }
            });
        }
    }

    function changePassword() {
        var $formWrapper = $(forms.ChangePassword.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.ChangePassword);

        $errorContainer.html('');

        if (isValid) {
            if (changePasswordData.$pass.val() !== changePasswordData.$pass2.val()) {
                Roc.UI.template('formErrorSummary-Tmp', { message: 'Given passwords aren\'t the same' }).then(function (renderedTemplate) {
                    $errorContainer.html(renderedTemplate);
                });
            } else {
                Roc.Core.lockButton(btns.changePass);
                var requestData = Roc.Validation.getFieldValues(forms.ChangePassword);

                $.ajax({
                    url: '/ajax/ResetPortalPassword',
                    type: 'POST',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json',
                    dataType: 'json',
                    complete: function (xhr) {
                        var response = xhr.responseJSON || {};
                        if (response.success && response.redir) {
                            window.location.replace(response.redir);
                        } else if (response.errorMessage) {
                            Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                        } else {
                            Roc.UI.ajaxErrorPopup(xhr);
                        }
                        Roc.Core.releaseLockedButton(btns.changePass);
                        Roc.EventManager.notify(Roc.Events.users.CHANGE_PASSWORD, xhr);
                    }
                });
            }
        }
    }

    function setUserLinkedInCustomField(request) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/portal/customer/linkedInProfile/set',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        });
    }

    function getUserLinkedInProfile() {
        $.proxyRequest({
            type: 'GET',
            url: '/api/portal/customer/linkedInProfile/get',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            complete: function (xhr) {
                var response = xhr.responseJSON || {};
                if (typeof response === 'string') {
                    $(selectors.linkedInProfileInput).val(response);
                }
            }
        });
    }

    function setApiSideCustomFields(customFields) {
        return $.proxyRequest({
            type: 'POST',
            url: '/api/portal/customer/customfields/set',
            data: JSON.stringify(customFields),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        });
    }

    function initPortalLogin(options) {
        loginOptions = options || {};
        loginData = {
            'email': Roc.Validation.getField(forms.PortalLogin, 'Email')
        };
        bindPortalLoginEvents();
    };

    function initPortalRegistration(options) {
        registrationOptions = options || {};
        bindPortalRegistrationEvents();
        var registrationFormWrapperContainer = $('#registerContainer');
        Roc.UI.block(registrationFormWrapperContainer);
        Roc.UI.renderFormTemplate('#portalRegisterForm-Tmp', registrationOptions.usStates, registrationFormWrapperContainer)
            .then(function () {
                Roc.UI.unblock(registrationFormWrapperContainer);
                bindPortalRegistrationEvents();
                buildStateDrpHtml($('#portalRegisterCountry').val());
            });      
        

       
    };


    function initEditProfile(options) {
        if (options) {
            this.editAccountOptions = options;
        }

        editUserData = {
            '$firstName': $(Roc.Validation.getField(forms.EditProfile, 'First Name').Field),
            '$lastName': $(Roc.Validation.getField(forms.EditProfile, 'Last Name').Field),
            '$linkedInProfile': $(Roc.Validation.getField(forms.EditProfile, 'LinkedIn Profile').Field)
        };
        getUserLinkedInProfile();
        bindUserProfileEvents();
    }


    function initEditAccount(options) {
        if (options) {
            this.editAccountOptions = options;
        }
        editAccountData = {
            '$newPass1': $(Roc.Validation.getField(forms.EditAccount, 'New Password').Field),
            '$newPass2': $(Roc.Validation.getField(forms.EditAccount, 'Retype New Password').Field)
        };
        bindEditAccountEvents();
    }

    function initForgotPassword(options) {
        forgotPasswordOptions = options || {};
        changePasswordData = {
            '$pass': $(Roc.Validation.getField(forms.ChangePassword, 'Password').Field),
            '$pass2': $(Roc.Validation.getField(forms.ChangePassword, 'Confirm Password').Field)
        };
        bindForgotPasswordEvents();
    }

    var PortalUsers = {
        forms: forms,
        initPortalLogin: initPortalLogin,
        initPortalRegistration: initPortalRegistration,
        initEditProfile: initEditProfile,
        initEditAccount: initEditAccount,
        portalLogin: portalLogin,
        portalRegister: portalRegister,
        initForgotPassword: initForgotPassword
    };

    Roc.Logger.debug('PortalUsers.js Loaded:', PortalUsers);

    return PortalUsers;
});
